<template>
  <div>
    <div class="display-1 font-weight-light mb-5">
      <span class="pl-5">Úvod</span>
      <v-divider></v-divider>
    </div>

    <div class="font-weight-light pl-5 pr-5">
      <p>Dobrý den, vítám Vás na svých profesních stránkách. Dovolte, abych se Vám v krátkosti představil.</p>
      <p>
        Jmenuji se Jiří Pazderník. O informační technologie jsem se začal zajímat už v dětství počátkem 80. let 20. století.
        Profesionálně se IT věnuji od počátku 90. let 20. století. První IT firmu jsme zakládali již v roce 1991,
        firma nabízela služby v obasti DTP, hardware a vývoj aplikací pro systémy DOS a Windows.
      </p>
      <p>
        S vývojem jsem začínal na starých dobrých osmibitech jako např. Atari, Sharp MZ 800 či Sinclair ZX Spectrum.
        V té době se vyvíjelo zejména v Assembleru, později pak vyšší programovací jazyky jako Pascal, Basic nebo C.
        S příchodem PC platformy přišly i sofistikovnější vývojové nástroje a jazyky jako např. Turbo Pascal,
        Borland Pascal, Turbo C, C++, Java a další.
      </p>
      <p>
        Postupem času a s rozvojem internetu jsem se začal věnovat zejména webovým techonologiím, webové bezpečnosti
        a rovněž databázím. Na tyto oblasti se specializuji i v současnosti. Zpočátku jsem se zaměřoval
        zejména na backendový vývoj, v posledních letech s příchodem javascriptových frameworků pracuji
        jako fullstack vývojář. Podílel jsem se na vývoji menších projektů i rozsáhlých portálů velkých a mezinárodních
        společností jako např. Sazka, Českomoravská stavební spořitelna, <span class="text-no-wrap">T-Mobile</span>, Allianz.
      </p>
      <p>
        Mimo vývoje jsem se zabýval i počítačovými sítěmi. Pár let jsem se podílel na administraci podnikové
        sítě založené na Windows NT, později jsem se začal specializovat na linux a BSD. I když se v současnosti
        administraci nevěnuji profesně, mám z této oblasti dlouhodobé zkušenosti a linuxové systémy zůstaly i mým koníčkem.
        Není pro mě problém nainstalovat a nakonfigurovat např. webový či databázový server, ostatně k vývoji a testování
        vždy používám virtuální stroje, aby byla zajištěna shoda s prostředím, na kterém poběží produkční verze vyvíjeného projektu.
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Home"
  }
</script>

<style scoped>

</style>
